/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Muscles_Why_TitleInputs */

const en_us2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why these targets?`)
};

const pt_br2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que essas metas?`)
};

const es_419_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué estas metas?`)
};

const pt_pt2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê estes objetivos?`)
};

const fr_fr2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ces objectifs ?`)
};

const de_de2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum diese Ziele?`)
};

const it_it2_progress_muscles_why_title = /** @type {(inputs: Progress_Muscles_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché questi obiettivi?`)
};

/**
* | output |
* | --- |
* | "Why these targets?" |
*
* @param {Progress_Muscles_Why_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_muscles_why_title = /** @type {((inputs?: Progress_Muscles_Why_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Muscles_Why_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_muscles_why_title(inputs)
	if (locale === "es-419") return es_419_progress_muscles_why_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_muscles_why_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_muscles_why_title(inputs)
	if (locale === "de-DE") return de_de2_progress_muscles_why_title(inputs)
	if (locale === "it-IT") return it_it2_progress_muscles_why_title(inputs)
	return en_us2_progress_muscles_why_title(inputs)
});
export { progress_muscles_why_title as "progress.muscles_why_title" }